import { Environment } from '../Environment';

export function getEnvironment(): Environment {
  return <Environment>process.env.NODE_ENV || Environment.DEVELOPMENT;
}
